import React from 'react'
import GeneralInfoRedesigned from './general-info-redesigned'

interface GeneralInformationProps {
  planNames: string[]
  customerData: any
  customerPlanData: any
}

const GeneralInformation: React.FC<GeneralInformationProps> = ({
  planNames,
  customerData,
  customerPlanData,
}) => {
  return (
    <GeneralInfoRedesigned
      planNames={planNames}
      customerData={customerData}
      customerPlanData={customerPlanData}
    />
  )
}

export default GeneralInformation
